import { Modal, IconButton, List, ListItem, Button } from "@mui/material";
import MDBox from "../MDBox";
import MDTypography from "../MDTypography";
import WestIcon from "@mui/icons-material/West";

const ModalLeaveInfo = (props) => {
  const { isOpen, onClose, data } = props;
  const leaveHistory = [
    { id: 1, type: "Contractual leaves", day: 20 },
    { id: 2, type: "Entitled leaves till this month", day: 2 },
    { id: 3, type: "Old leaves", day: 9 },
    { id: 4, type: "Total leaves taken till this month", day: 4 },
    { id: 5, type: "Old leaves taken", day: 4 },
    { id: 6, type: "Total entitled leaves", day: 4 },
  ];

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="modal-leave-info-container">
        <div className="modal-leave-info-container-wrapper">
          <MDBox className="modal-leave-info-header">
            <IconButton onClick={onClose} size="small" className="close-icon">
              <WestIcon />
            </IconButton>
            <MDTypography className="modal-leave-info-title" variant="h5">
              Leave information
            </MDTypography>
          </MDBox>

          <MDBox className="modal-leave-info-content">
            <List className="modal-leave-info-form">
              {leaveHistory.map((leave, index) => (
                <ListItem
                  className="modal-leave-info-form-item"
                  key={leave.id}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <MDTypography variant="subtitle1" className="type">
                    {leave.type}
                  </MDTypography>
                  <MDTypography variant="subtitle1" className="day">
                    {leave.day}
                  </MDTypography>
                  {index < leaveHistory.length - 1 && (
                    <hr
                      style={{
                        borderColor: "eeeeee",
                        width: "100%",
                        marginTop: "15px",
                        marginBottom: "0px",
                      }}
                    />
                  )}
                </ListItem>
              ))}
            </List>
          </MDBox>
          <MDBox className="modal-leave-info-footer">
            <Button
              className="cancel-button"
              variant="contained"
              fullWidth
              color="primary"
              onClick={onClose}
            >
              Close
            </Button>
          </MDBox>
        </div>
      </div>
    </Modal>
  );
};

export default ModalLeaveInfo;
